<div class="search-bar-container">
    <div class="search-bar-wrapper" *ngIf="!showUserListDropDown && !showTagListDropDown">
        <div class="search-box">
            <span class="search-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                    d="M13.8067 12.8602L11.54 10.6002C12.2713 9.66855 12.6681 8.51802 12.6667 7.33358C12.6667 6.27875 12.3539 5.2476 11.7678 4.37054C11.1818 3.49348 10.3489 2.80989 9.37431 2.40622C8.39978 2.00255 7.32742 1.89694 6.29285 2.10273C5.25829 2.30851 4.30798 2.81646 3.5621 3.56234C2.81622 4.30822 2.30827 5.25853 2.10248 6.2931C1.89669 7.32766 2.00231 8.40002 2.40598 9.37456C2.80965 10.3491 3.49323 11.1821 4.37029 11.7681C5.24736 12.3541 6.2785 12.6669 7.33334 12.6669C8.51777 12.6684 9.66831 12.2716 10.6 11.5402L12.86 13.8069C12.922 13.8694 12.9957 13.919 13.077 13.9528C13.1582 13.9867 13.2453 14.0041 13.3333 14.0041C13.4213 14.0041 13.5085 13.9867 13.5897 13.9528C13.671 13.919 13.7447 13.8694 13.8067 13.8069C13.8692 13.7449 13.9188 13.6712 13.9526 13.59C13.9864 13.5087 14.0039 13.4216 14.0039 13.3336C14.0039 13.2456 13.9864 13.1584 13.9526 13.0772C13.9188 12.996 13.8692 12.9222 13.8067 12.8602ZM3.33334 7.33358C3.33334 6.54245 3.56793 5.7691 4.00746 5.1113C4.44698 4.4535 5.0717 3.94081 5.8026 3.63806C6.53351 3.33531 7.33777 3.2561 8.1137 3.41044C8.88962 3.56478 9.60235 3.94574 10.1618 4.50515C10.7212 5.06456 11.1021 5.77729 11.2565 6.55322C11.4108 7.32914 11.3316 8.13341 11.0289 8.86431C10.7261 9.59522 10.2134 10.2199 9.55562 10.6595C8.89782 11.099 8.12446 11.3336 7.33334 11.3336C6.27247 11.3336 5.25505 10.9122 4.50491 10.162C3.75476 9.41186 3.33334 8.39445 3.33334 7.33358Z"
                    fill="#8E8E8E"/>
            </svg>
        </span>

            <input
                appDebounceTimer
                type="search"
                class="search-input"
                [(ngModel)]="searchText"
                [placeholder]="placeHolder"
                (valueChanged)="searchItem($event)">

            <ng-container *ngIf="!isHideClearBtn">
                <div class="clear-search" [hidden]="!searchText" (click)="clearSearch()">
                    <i class="fas fa-times-circle"></i>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="search-container" *ngIf="showUserListDropDown || showTagListDropDown">
        <div class="search-bar">
            <div class="search-icon-wrapper">
                <i class="fa fa-search search-icon" aria-hidden="true"></i>
            </div>
            <div class="left-spacing"></div>
            <ng-container *ngFor="let user of usersList">
                <span class="selected-user" *ngIf="user.selected">
                    <img alt="Avatar"
                         class="profile-radius pointer-cursor img-width user-selected-profile-pic"
                         [src]="user?.profile!= null && user?.profile !='' && user.profile != 'NULL' ? user.profile : 'images/profile_avatar_small.jpg'">
                    <span class="user-profile-name">{{ user.name }}</span>
                    <span class="remove-user" (click)="removeUser(user)"><i class="fa fa-times"
                                                                            aria-hidden="true"></i></span>
                </span>
            </ng-container>
            <ng-container *ngFor="let tag of tagsList">
                <span class="selected-user" *ngIf="tag.selected">
                    <span class="user-profile-name">#{{ tag.description }}</span>
                    <span class="remove-user" (click)="removeTag(tag)"><i class="fa fa-times"
                                                                          aria-hidden="true"></i></span>
                </span>
            </ng-container>
            <input class="search-input" [(ngModel)]="searchInputValue"  [placeholder]="(getSelectedUserId().length || getSelectedTagIds().length) ? '' : 'Search'"
                    (focusout)="searchLeave()"
                   (input)="onSearch($event)">
            <div class="clear-input-wrapper" *ngIf="searchInputValue || getSelectedUserId().length || getSelectedTagIds().length">
                <i class="fa fa-times-circle clear-input" aria-hidden="true" (click)="clearSearchValue()"></i>
            </div>
        </div>
        <ul class="dropdown-list" [style.display]="showSearchDropdown ? 'block' : 'none'">
            <li *ngFor="let user of filteredUsers" (click)="selectUser(user)">
                {{ user?.name }}
            </li>
        </ul>
        <ul class="dropdown-list tag-dropdown-list" [style.display]="showTagSearchDropdown ? 'block' : 'none'">
            <li *ngFor="let tag of filteredTags" (click)="selectTag(tag)">
                #{{ tag?.description }}
            </li>
        </ul>
    </div>
</div>
